import { useMutation } from 'react-query';
import { getTokensDeleteRequest } from './requests';
export var useDeleteTokens = function useDeleteTokens() {
    return useMutation(function (body) {
        return getTokensDeleteRequest(body);
    });
};
